import React, { useState } from 'react';
import {Grid,Box,Typography,  TextField,Button,Checkbox,FormControlLabel} from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;
  const [showPassword, setShowPassword] = useState(false);
  const [data, setData] = useState({
    email: email,
    password: '',
    confirmPassword: ''
  });
  const [errortext, setErrortext] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (data.password === data.confirmPassword) {
      axios
        .put(`${process.env.REACT_APP_API_LINKS}/forgot/updatepassword`, data)
        .then((res) => {
          if (res.status === 200) {
            Swal.fire({
              icon: 'success',
              title: 'Password Updated Successfully!',
              timer: 500,
              showConfirmButton: false
            });
            navigate('/login')
          }
        })
        .catch(() => {
          Swal.fire({
            icon: 'error',
            title: 'Password Update failed!',
            timer: 500,
            showConfirmButton: false
          });
        });
    } else {
      alert('Password Change failed!');
      setErrortext(true);
    }
  };

  const handler = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <Grid
      container
      sx={{
        minHeight: '100vh',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 2, sm: 4, md: 5 },
        py: { xs: 4, md: 5 },
        gap: { xs: 4, md: 0 }
      }}
    >
      {/* LEFT SECTION */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          mb: { xs: 2, md: 0 },
          mt: { md: 6, lg: 5 },
          mr: { md: 2, lg: 20 }
        }}
      >
        <img
          src="suntech_logo.png"
          alt="Logo"
          style={{ height: 75, marginBottom: 12 }}
        />

        <Typography
          variant="h4"
          sx={{ mt: 4, fontWeight: 600, fontFamily: 'poppins' }}
        >
          Welcome
        </Typography>

        <img
          src="setpassword.png"
          alt="Change Password Visual"
          style={{ width: '70%', maxWidth: 400, marginTop: 30 }}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mt: { xs: 0, md: 0 },
          ml: { md: 0, lg: 15 }
        }}
      >
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            width: '100%',
            maxWidth: 400,
            p: { xs: 3, sm: 4 },
            boxShadow: 5,
            borderRadius: 2,
            backgroundColor: '#fff',
            mx: 'auto'
          }}
        >
          <Typography
            variant="h5"
            sx={{ mb: 2, fontWeight: 600, fontFamily: 'poppins' }}
          >
            Change Password
          </Typography>

          <Typography
            variant="body2"
            sx={{ mb: 3, fontFamily: 'poppins', color: 'text.secondary' }}
          >
            Please enter your new password below:
          </Typography>

          <TextField
            type={showPassword ? 'text' : 'password'}
            name="password"
            label="Password"
            value={data.password}
            fullWidth
            required
            onChange={handler}
            sx={{
              mb: 2,
              '& .MuiOutlinedInput-root': { borderRadius: '10px' }
            }}
          />

          <TextField
            type={showPassword ? 'text' : 'password'}
            name="confirmPassword"
            value={data.confirmPassword}
            label="Confirm Password"
            fullWidth
            required
            onChange={handler}
            error={errortext}
            helperText={errortext ? "Passwords don't match" : ''}
            FormHelperTextProps={{
              sx: {
                color: 'error.main',
                fontSize: '12px',
                marginLeft: 0
              }
            }}
            sx={{
              mb: 2,
              '& .MuiOutlinedInput-root': { borderRadius: '10px' }
            }}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={showPassword}
                onChange={toggleShowPassword}
              />
            }
            label="Show Password"
            sx={{ mb: 2 }}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: '#007ee5',
              textTransform: 'none',
              fontWeight: 600,
              mb: 1,
              fontFamily:'poppins'
            }}
          >
            Change Password
          </Button>
          <Link to='/login'>
          <Button
            variant="text"
            fullWidth
            sx={{
              fontWeight: 600,
              color: 'text.secondary',
              fontFamily: 'poppins',
              textTransform: 'none'
            }}
          >
            Cancel
          </Button>
          </Link>
        </Box>
      </Grid>
    </Grid>
  );
}
